import { ReadXlsxWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('ReadXlsx')
export class ReadXlsxNodeSchemaProvider extends SchemaProvider<ReadXlsxWorkflowNode> {}
